import { render, staticRenderFns } from "./TouristComplaint.vue?vue&type=template&id=8af01010&scoped=true&"
import script from "./TouristComplaint.vue?vue&type=script&lang=js&"
export * from "./TouristComplaint.vue?vue&type=script&lang=js&"
import style0 from "./TouristComplaint.vue?vue&type=style&index=0&id=8af01010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af01010",
  null
  
)

export default component.exports